import { render, staticRenderFns } from "./serviceCharge.vue?vue&type=template&id=4e9da2cd&scoped=true&"
import script from "./serviceCharge.vue?vue&type=script&lang=js&"
export * from "./serviceCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9da2cd",
  null
  
)

export default component.exports